import React, { useEffect, useState, useRef,useContext } from 'react';
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { Modal } from '../../components/modal/Modal';
import { UserContext } from '../../../context/provider/UserProvider';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';

import { useGroups } from '../../../hooks/grupos/useGroups';
import { useCompany } from '../../../hooks/grupos/useCompany';
import { guardarFotoGrupoChat } from '../../../utils/utils';
import { useSpinner } from '../../../hooks/useSpinner';
import { LineaCarga } from '../../components/LineaCarga';



export const Grupos =()=>{
    const classNameInput = "text-white h-[30px] rounded caret-white px-2 w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const classNameSelect = "text-white h-[30px] rounded px-2 bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 containerScroll"
    const fotoDefault = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3aYoBJuTIzugm2Gmdkz6oY9VaHqYdHRUznyruA2s-mA&s'
    const [ fotoFile, setFotoFile ] = useState(null); 
    const [ fotoGrupo, setFotoGrupo ] = useState(fotoDefault);
    const [ empresaSeleccionada, setEmpresaSeleccionada ] = useState(0)
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const {
        grupo,
        grupos,
        rutas,
        listarGruposPorEmpresa,
        guardarEditarGrupo,
        editarValorGrupo,
        obtenerDatosGrupoModulo,
        listarRutasPorEmpresa,
        openModalRegistrar,
        isOpenModalRegistrar,
        closeModalRegistrar,
        loading

    } = useGroups()

    const {
        listarEmpresa,
        empresas
    } =  useCompany()

    useEffect(() => {
       listarEmpresa()
    },[])

    useEffect(() => {
        empresas.length > 0 && listarGruposPorEmpresa(empresaSeleccionada === 0 ? empresas[0].CodEmpresa : empresaSeleccionada)
    },[empresas])

    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            return
        }
        const objectUrl = URL?.createObjectURL(e.target.files[0])
        setFotoFile(e.target.files[0])
        setFotoGrupo(objectUrl)
    }

    const guardarGrupo = async () =>{
        mostrarSpinner()
        const guardoFoto = (
            fotoFile === null ? 
                [{isValid: true, urlImagen: ''}] 
            :  
                await guardarFotoGrupoChat(fotoFile,{nomCarpeta:'teguio',nomSubcarpeta: 'fotos-comunidad', nomArchivo: grupo.IdRoom})
        )
        if(guardoFoto[0].isValid){
            const isValid = await guardarEditarGrupo(guardoFoto[0].urlImagen)
            if(isValid){
                listarGruposPorEmpresa(empresaSeleccionada === 0 ? empresas[0].CodEmpresa : empresaSeleccionada)
                closeModalRegistrar()
            }
        }
        ocultarSpinner()
    }

    return(
        <>
            <ContenedorParametros titulo="Grupos">
                <select
                    className={`${classNameSelect} lg:w-[200px]`}
                    onChange={(e) => {
                        setEmpresaSeleccionada(parseInt(e.target.value))
                        listarGruposPorEmpresa(e.target.value)
                    }}
                >
                    {/* <option value={0} key={0}>--Seleccione--</option> */}
                    {
                        empresas.length > 0 &&
                            empresas.map( e => (
                                <option key={e.CodEmpresa} value={e.CodEmpresa}>{e.RazonSocialEmpresa}</option>
                            ))
                    }
                </select>
                {/* <BotonProcesar onClick={()=>listarGruposPorEmpresa(empresaSeleccionada)} ></BotonProcesar> */}
                <BotonNuevo
                    onClick={async ()=> {
                        await obtenerDatosGrupoModulo()
                        setFotoFile(null)
                        setFotoGrupo(fotoDefault)
                        openModalRegistrar()
                    }}
                >NUEVO</BotonNuevo>
            </ContenedorParametros>
            {loading && <LineaCarga/>}
            <ContenedorTabla>
                <div className='containerScroll  mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                    <table className="table ">
                        <thead>
                            <tr>
                                <th className="text-center">N</th>
                                <th className="text-center">NOMBRE</th>
                                <th className="text-center">DESCRIPCION</th>
                                <th className='text-center'>RUTA</th>
                                <th className='text-center'>PARTICIPANTES</th>
                                <th className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {   
                            grupos?.length > 0 
                            ? grupos?.map((g, i) => {
                                return (
                                    <tr key={++i}>
                                        <td className='text-center'>{ ++i}</td>
                                        <td className="text-center">{g.NomGrupo}</td>
                                        <td className="text-center">{g.Descripcion}</td>
                                        <td className="text-center">{g.NomRuta}</td>
                                        <td className="text-center">{g.CantidadParticipantes}</td>
                                        <td className="text-center">
                                            <button
                                                className='bg-blue-600 rounded-md px-2'
                                                onClick={async () => {
                                                    await obtenerDatosGrupoModulo(g)
                                                    setFotoGrupo(g.UrlFotoPerfil)
                                                    openModalRegistrar()

                                                }}
                                            >
                                                <i className='fa fa-pen'></i>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="7" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody>
                    </table>
                </div>
            </ContenedorTabla>

            <Modal 
                isOpen={isOpenModalRegistrar}
                closeModal={closeModalRegistrar}
                action={()=>guardarGrupo()}
                title={`${grupo.CodGrupo === 0 ? "Registrar Nuevo Grupo" : `Editar [ ${grupo.NomGrupo} ]` }`}
                spinner={spinner}
                textButtons={{ confirm: 'Guardar', denied: 'Cerrar' }}
                validButton={{ confirm: true, denied: true}}
            >
                {
                    isOpenModalRegistrar &&
                        <div 
                            className="p-2 w-[400px] lg:w-[350px] flex  flex-col text-center justify justify-center"
                            key={grupo.nameRoom}
                        >
                            {/* <div className='flex  flex-col text-center justify justify-center'> */}
                                <label htmlFor="file-1" className='flex flex-col items-center'> 
                                    <input
                                        // ref={inputFoto}
                                        type="file"
                                        name="file-1"
                                        id="file-1"
                                        className="inputfile inputfile-1 hidden" accept='.jpg,.png'
                                        onChange={onSelectFile}
                                    />
                                    <img
                                        // key={currentRoom?.nameRoom}
                                        className='rounded-full w-[250px] h-[250px] mb-1 lg:w-[150px] lg:h-[150px] border border-gray-500 cursor-pointer '
                                        src={fotoGrupo}
                                        alt=''
                                    />
                                    <i
                                        className="fa fa-image iborrainputfile text-[#FFFFFF] text-xl
                                        bg-green-600 px-2 rounded cursor-pointer hover:bg-green-300"
                                    ></i> 
                                </label>                            
                                <div className='flex flex-col  text-left'>
                                    <span>Nombre Grupo</span>
                                    <input
                                        className={` ${classNameInput} lg:w-[330px] caret-white`}
                                        value={grupo.NomGrupo||''}
                                        onChange={(e)=>editarValorGrupo("NomGrupo",e.target.value)}
                                    /> 
                                    <span>Descripción</span>
                                    <textarea
                                        className={` ${classNameInput} h-[80px] lg:w-[330px] caret-white `}
                                        value={grupo.Descripcion}
                                        onChange={(e)=>editarValorGrupo("Descripcion",e.target.value)}
                                    />
                                    {
                                        grupo.CodGrupo === 0 &&
                                        <>
                                            <span>Empresa</span>
                                            <select
                                                className={`${classNameSelect} lg:w-[330px]`}
                                                onChange={async (e) => {
                                                    await listarRutasPorEmpresa(e.target.value);
                                                    editarValorGrupo("CodEmpresa",parseInt(e.target.value));
                                                }}
                                            >
                                                <option value={0} key={0} className='text-center'>--Seleccione--</option>
                                                {
                                                    empresas.length > 0 && 
                                                        empresas.map( e => (
                                                            <option key={e.CodEmpresa} value={e.CodEmpresa}>{e.RazonSocialEmpresa}</option>
                                                        ))
                                                }
                                            </select>
                                            <span>Ruta</span>
                                            <select
                                                className={`${classNameSelect} lg:w-[330px]`}
                                                onChange={(e) => {
                                                    editarValorGrupo("CodRuta",parseInt(e.target.value))        
                                                    editarValorGrupo("NomRuta",e.target.options[e.target.selectedIndex].text)        
                                                }}
                                            >
                                                <option value={0} key={0} className='text-center'>--Seleccione--</option>
                                                {
                                                    rutas.length > 0 &&
                                                        rutas.map(r => (
                                                            <option  key={r.CodRuta} value={r.CodRuta}>{r.NomRuta}</option>
                                                        ))
                                                }
                                            </select>
                                        </>
                                    }
                                </div>
                            {/* </div> */}
                        </div>
                }
            </Modal>

        </>
    )


}